import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';

/**
 * AbodeLMS shared admin theme.
 *
 * Goal is "modern SaaS product, not flashy" — restrained enough to
 * stay out of the way of dense data screens, distinctive enough to
 * not look like out-of-the-box PrimeVue Aura. Two palette decisions
 * carry most of the weight:
 *
 *   1. Primary accent is a muted slate-blue (#476a8a core) — calm,
 *      professional, ages well, and doesn't fight the warm L&TC
 *      landing aesthetically.
 *   2. Surface scale is a warm neutral (slight cream cast) instead of
 *      Aura's default cool-grey, so the canvas reads as paper rather
 *      than monitor-white. Easier on the eyes for long sessions.
 *
 * We extend Aura rather than replacing it so PrimeVue's component
 * affordances (focus rings, hover states, density) stay intact.
 */
export const abodeTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#f4f7fa',
      100: '#e4ebf2',
      200: '#c4d3e0',
      300: '#9bb3c8',
      400: '#6c8caa',
      500: '#476a8a',
      600: '#3a5872',
      700: '#30485e',
      800: '#2a3d4f',
      900: '#243343',
      950: '#16212d',
    },
    colorScheme: {
      light: {
        surface: {
          0:   '#ffffff',
          50:  '#faf8f4',
          100: '#f1ede5',
          200: '#e1dbcf',
          300: '#c8c1b3',
          400: '#a39b8c',
          500: '#7d756a',
          600: '#5d564d',
          700: '#423d36',
          800: '#2c2823',
          900: '#1a1815',
          950: '#0e0d0b',
        },
        formField: {
          background: '#ffffff',
          borderColor: '#dcd6c9',
          hoverBorderColor: '#bdb6a6',
          focusBorderColor: '#476a8a',
        },
        content: {
          background: '#faf8f4',
          borderColor: '#e1dbcf',
        },
      },
      dark: {
        surface: {
          0:   '#faf8f4',
          50:  '#f1ede5',
          100: '#dfd9cc',
          200: '#c5beae',
          300: '#a09a8c',
          400: '#7a7466',
          500: '#5a554b',
          600: '#3a372f',
          700: '#2a2823',
          800: '#1f1d1a',
          900: '#161512',
          950: '#0e0d0b',
        },
      },
    },
  },
});
